
  import GDetail from '@/components/toolkit'

  export { GDetail }
  export default GDetail
